module.exports = __webpack_public_path__ + "media/coffee-preferences/main_flavor_sweet-10648b99.png";